import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import { listMaps, mapBlocker } from '../utils/maps';
import { DEFAULT_RUN_LEVELS } from '../utils/StateProvider';
import { normaliseSeed } from '../utils/rng';
import { isMuted, toggleMuted, primeAudio, playSound } from '../utils/audio';
import { describeParty } from '../utils/saves';

const LEVEL_CHOICES = [1, 5, 10, 20];

const CONTROLS = [
  ['Move', 'W A S D / arrow keys, Q and E to step sideways'],
  ['Use', 'F uses stairs, chests, doors and the trainer'],
  ['Bash', 'B throws the front two at a locked door'],
  ['Shoot', 'X fires at anything in sight ahead'],
  ['Cast', 'C, then pick the caster and the spell'],
  ['Combat', 'A attack, S shoot, C cast, B block, R run, Q quick fight, W wait'],
  ['Target', 'Tab or click a foe to change target'],
];

// Title screen: pick a seed and a length, then descend.
class LaunchMenu extends Component {
  state = {
    seed: this.props.context.newSeed(),
    levels: DEFAULT_RUN_LEVELS,
    muted: isMuted(),
    saves: this.props.context.listParties(),
    // The saved party to take down, or null for fresh recruits
    chosen: null,
    maps: listMaps(),
    // A painted town to start in, or null for one built from the seed
    town: null,
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = (e) => {
    if (e.key === 'Enter') this.start();
  }

  start = () => {
    // The first tap is what lets the browser play sound at all
    primeAudio();
    playSound('stairs');
    const save = this.state.saves.find((s) => s.name === this.state.chosen) || null;
    const town = this.state.maps.find((m) => m.name === this.state.town) || null;
    this.props.context.startRun(normaliseSeed(this.state.seed), this.state.levels, save, town);
  }

  forget = (name) => {
    this.props.context.deleteParty(name);
    this.setState((state) => ({
      saves: this.props.context.listParties(),
      chosen: state.chosen === name ? null : state.chosen,
    }));
  }

  renderParties() {
    const { saves, chosen } = this.state;
    if (!saves.length) return null;
    return (
      <div className="menu-row menu-parties">
        <span>Party</span>
        <div className="party-choices">
          <button
            className={classNames('menu-button', 'small', { chosen: chosen === null })}
            onClick={() => this.setState({ chosen: null })}
          >
            NEW PARTY
          </button>
          {saves.map((save) => (
            <button
              key={save.name}
              className={classNames('menu-button', 'small', 'saved-party', { chosen: chosen === save.name })}
              onClick={() => this.setState({ chosen: save.name })}
            >
              {save.name}
              <span className="party-detail">{describeParty(save)}</span>
              <span className="party-forget" title="Forget this party"
                    onClick={(e) => { e.stopPropagation(); this.forget(save.name); }}>✕</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  toggleSound = () => {
    const muted = toggleMuted();
    this.setState({ muted });
    if (!muted) playSound('click');
  }

  render() {
    return (
      <div id="launchMenu">
        <div className="menu-panel">
          <h1>FRPG</h1>
          <p className="menu-tagline">A dungeon crawl in the old style</p>

          <label className="menu-row">
            <span>Seed</span>
            <input
              value={this.state.seed}
              maxLength={24}
              onChange={(e) => this.setState({ seed: e.target.value.toUpperCase() })}
            />
            <button className="menu-button small" onClick={() => this.setState({ seed: this.props.context.newSeed() })}>
              RANDOM
            </button>
          </label>
          <p className="menu-hint">The same seed always builds the same dungeon.</p>

          {this.renderParties()}

          <div className="menu-row">
            <span>Sound</span>
            <button className={classNames('menu-button', 'small', { chosen: !this.state.muted })} onClick={this.toggleSound}>
              {this.state.muted ? 'OFF' : 'ON'}
            </button>
            <span className="menu-hint">also in the gem menu, mid-run</span>
          </div>

          <div className="menu-row">
            <span>Levels</span>
            {LEVEL_CHOICES.map((n) => (
              <button
                key={n}
                className={classNames('menu-button', 'small', { chosen: this.state.levels === n })}
                onClick={() => this.setState({ levels: n })}
              >
                {n}
              </button>
            ))}
          </div>

          <div className="menu-row">
            <span>Town</span>
            <button
              className={classNames('menu-button', 'small', { chosen: !this.state.town })}
              onClick={() => this.setState({ town: null })}
            >
              GENERATED
            </button>
            {this.state.maps.filter((map) => !mapBlocker(map)).map((map) => (
              <button
                key={map.name}
                className={classNames('menu-button', 'small', { chosen: this.state.town === map.name })}
                onClick={() => this.setState({ town: map.name })}
              >
                {map.name}
              </button>
            ))}
            <button className="menu-button small" onClick={this.props.context.openEditor}>MAP EDITOR</button>
          </div>

          <button className="menu-button start" onClick={this.start}>BEGIN THE DESCENT (ENTER)</button>

          <div className="menu-controls">
            {CONTROLS.map(([name, keys]) => (
              <div key={name} className="menu-control"><span>{name}</span><span>{keys}</span></div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withContext(LaunchMenu);
